import betterLuckUrl from '../../assets/wheel/better_luck.png';

/**
 * Zero-winnings consolation dialogue for the multiplayer wheel
 * (producer brief 2026-06-08). Shown over the wheel after the spin
 * lands when the local player's net winnings come out at zero (or
 * below) — a warm "better luck next time" card with commissioned art,
 * in place of a bare "WINNINGS 0" ledger.
 *
 * <p>Presentational only: the host ({@code WheelResolveView}) owns the
 * zero-winnings detection + the post-spin timing and simply mounts /
 * unmounts this. A dimming backdrop covers the Pixi winnings ledger
 * underneath so the card reads as a clean replacement.
 */
export function BetterLuckDialog() {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background:
          'radial-gradient(ellipse at center, rgba(6,10,30,0.5) 0%, rgba(4,6,18,0.8) 100%)',
        backdropFilter: 'blur(3px)',
        WebkitBackdropFilter: 'blur(3px)',
        pointerEvents: 'none',
        fontFamily: '"Fredoka", -apple-system, system-ui, sans-serif',
        animation: 'gtBLBackdrop 260ms ease both',
      }}
    >
      <div
        style={{
          width: 'min(340px, 100%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          padding: '24px 24px 28px',
          borderRadius: 24,
          border: '2px solid rgba(255,201,64,0.85)',
          background: 'linear-gradient(180deg, #2a1e63 0%, #16113d 62%)',
          boxShadow:
            '0 18px 50px rgba(0,0,0,0.6), 0 0 34px rgba(120,200,255,0.16), inset 0 0 0 1px rgba(255,226,138,0.35)',
          animation: 'gtBLCard 380ms cubic-bezier(0.18,0.7,0.32,1) both',
        }}
      >
        <img
          src={betterLuckUrl}
          alt=""
          width={168}
          height={168}
          draggable={false}
          style={{
            objectFit: 'contain',
            filter: 'drop-shadow(0 8px 18px rgba(0,0,0,0.45))',
          }}
        />
        <h2
          style={{
            margin: '12px 0 0',
            fontSize: 24,
            fontWeight: 900,
            letterSpacing: 0.3,
            color: '#FFE28A',
            textShadow: '0 2px 6px rgba(0,0,0,0.5)',
          }}
        >
          Better luck next time
        </h2>
        <p
          style={{
            margin: '8px 0 0',
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 1.4,
            color: 'rgba(233,240,255,0.82)',
          }}
        >
          The wheel didn’t land your way this round. Your luck’s just warming up.
        </p>
      </div>
      <style>{`
        @keyframes gtBLBackdrop { 0% { opacity: 0; } 100% { opacity: 1; } }
        @keyframes gtBLCard {
          0%   { opacity: 0; transform: translateY(14px) scale(0.86); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
    </div>
  );
}
